import StepController, { StepError } from "../../../lib/config_tool_step"

// Flash-Schritt des Stationslaufs. Lädt die gepinnte Firmware über die Shell in eine temporäre Datei (files.download,
// mit der Session des Fensters), flasht sie mit dem Tool des Slots (heute nur ST-Link; die Adresse nur bei .bin) und
// löscht die Datei wieder.
export default class extends StepController {
  static values = {
    url: String,
    filename: String,
    tool: String,
    address: String,
    downloading: String,
    flashing: String,
    done: String,
    unsupportedTool: String,
  }

  async perform() {
    this.reset()
    try {
      if (this.toolValue !== "stlink") throw new StepError("unsupported_tool", `${this.unsupportedToolValue} ${this.toolValue}`)

      this.status(this.downloadingValue)
      const file = await this.bridge.files.download({ url: this.urlValue, filename: this.filenameValue })
      try {
        this.status(this.flashingValue)
        this.output(await this.bridge.stlink.flash({ filePath: file, address: this.addressValue }))
      } finally {
        await this.bridge.files.remove(file).catch(() => {})
      }
      this.status(this.doneValue)
    } catch (error) {
      this.failed(error)
    }
  }
}
